export default "__VITE_ASSET__D$nvzg1Z__"